/* eslint-disable angular/controller-name */

(function iife() {
	"use strict";

	angular.module("dx.webapp.node").controller("NodeMergeRouteController", NodeMergeRouteController);

	function NodeMergeRouteController(
		$window,
		$http,
		$routeParams,
		$location,
		NodeRepository,
		DX_URLS
	) {
		var self = this;
		var mergeStatusEnum = {
			mergeCheck: {
				cancelButtoni18n: "Cancel",
				mergeButtoni18n: "MergeSelectedOrganizations.mergeCheck.button",
			},
			mergePossible: {
				cancelButtoni18n: "Cancel",
				mergeButtoni18n: "MergeSelectedOrganizations.mergePossible.button",
				statusi18n: "MergeSelectedOrganizations.mergePossible.status",
			},
			mergePayingPossible: {
				cancelButtoni18n: "Cancel",
				mergeButtoni18n: "MergeSelectedOrganizations.mergePossible.button",
				statusi18n: "MergeSelectedOrganizations.mergePayingPossible.status",
			},
			mergeDone: {
				cancelButtoni18n: "Close",
				mergeButtoni18n: "MergeSelectedOrganizations.mergePossible.button",
				statusi18n: "MergeSelectedOrganizations.mergeDone.status",
			},
			mergeFailed: {
				cancelButtoni18n: "Close",
				mergeButtoni18n: "MergeSelectedOrganizations.mergePossible.button",
			},
		};
		var selectedNodeIds = $routeParams.id.split(",");
		var sourceNodes = [];

		self.mergeStarted = false;
		self.isMergePossible = false;
		self.mergeStatus = mergeStatusEnum.mergeCheck;
		self.mergeFailed = false;
		self.selectedNodes = [];
		self.studentCodeConflicts = [];
		self.orgIdErrors = [];
		self.targetNode = null;

		// Clears out previous error messages and resets the isMerge flag to false
		self.setDirty = function setDirty() {
			self.mergeStatus = mergeStatusEnum.mergeCheck;
			self.studentCodeConflicts = [];
			self.orgIdErrors = [];
			self.isMergePossible = false;
		};

		self.merge = function merge() {
			if (self.isMergePossible === false) {
				checkIfMergeIsPossible();
			} else {
				mergeOrganizations();
			}
		};

		function checkIfMergeIsPossible() {
			sourceNodes = selectedNodeIds.slice();
			$http.get("/node/mergestatus/?nodeIds=" + sourceNodes.join(",") + "&targetNodeId=" + self.targetNode.id).
			then(assignMergeStatusData, errorMergeStatusData);
		}

		function assignMergeStatusData(response) {
			self.setDirty();

			if (response.data.mergePossible === true) {
				self.isMergePossible = true;
				if (self.targetNode.freemium) {
					self.mergeStatus = mergeStatusEnum.mergePossible;
				} else {
					self.mergeStatus = mergeStatusEnum.mergePayingPossible;
				}
				return;
			}

			if (response.data.customerOrganizationIds) {
				self.selectedNodes.forEach(function foreachSelectedNode(node) {
					if (response.data.customerOrganizationIds.indexOf(node.id) !== -1) {
						self.orgIdErrors.push(
							{
								name: node.title,
								id: node.id,
							}
						);
					}
				});
			}
		}

		function errorMergeStatusData(data) {
			$window.console.log("Error", data);
		}

		function mergeOrganizations() {
			self.mergeStarted = true;
			$http.post("/node/merge/?nodeIds=" + sourceNodes.join(",") + "&targetNodeId=" + self.targetNode.id).
			then(mergeSuccess, mergeError);
		}

		function mergeSuccess() {
			self.mergeStatus = mergeStatusEnum.mergeDone;
		}

		function mergeError(data) {
			mergeStatusEnum.mergeFailed.statusi18n = data;
			self.mergeStatus = mergeStatusEnum.mergeFailed;
			self.isMergePossible = false;
			self.mergeFailed = true;
		}

		self.cancel = function cancel() {
			$location.path(DX_URLS.get("node"));
		};

		function getOrganizations() {
			selectedNodeIds.forEach(function nodeIterator(nextNode) {
				NodeRepository.load(nextNode).then(function success(response) {
					self.selectedNodes.push(response);
				});
			});
		}

		getOrganizations();
	}
}());
